(function () {
  function init() {
    const config = window.productPersonalizerConfig;
    const root = document.querySelector('[data-personalizer-root]');

    if (!config || !root || !window.PersonalizerModalApp || !window.fabric) {
      return;
    }

    const app = new window.PersonalizerModalApp(root, config);
    app.init();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
